import {Divider} from 'src/design/atoms/Divider';
import {Stack} from 'src/design/atoms/Stack';
import React from 'react';
import type {
  AttachmentModuleEnum,
  AttachmentSimpleResponse,
} from 'src/api/ProactApiClient';
import {NoItemsPanel} from 'src/design/molecules/NoItemsPanel';
import {Paginator} from 'src/design/organisms/Pagination';
import {TableBodyRender} from 'src/design/molecules/TableBodyRender';
import {isValidArray} from 'src/utilities/objectUtils';
import {AttachmentsListRow} from './AttachmentsListRow';

export interface AttachmentsListProps {
  entityId: number;
  attachmentType: AttachmentModuleEnum;
  data: AttachmentSimpleResponse[];
  currentPage: number;
  totalRecords: number;
  recordsPerPage?: number;
  isLoading: boolean;
  noDataText?: string;
  onPageChange?: (event: React.ChangeEvent<unknown>, page: number) => void;
  onInvalidateState: () => void;
}
export const AttachmentsList = ({
  entityId,
  attachmentType,
  data,
  currentPage,
  totalRecords,
  recordsPerPage = 10,
  noDataText,
  onPageChange,
  isLoading,
  onInvalidateState,
}: AttachmentsListProps) => (
  <Stack gap="xs">
    {isLoading ? (
      <TableBodyRender isLoading={isLoading} hasData={isValidArray(data)} />
    ) : (
      <>
        {data.map(row => (
          <React.Fragment key={row.id}>
            <Divider />
            <AttachmentsListRow
              entityId={entityId}
              attachmentType={attachmentType}
              data={row}
              onDeleted={onInvalidateState}
              onEdited={onInvalidateState}
            />
          </React.Fragment>
        ))}
        <Paginator
          mt={24}
          perPage={recordsPerPage}
          currentPage={currentPage}
          totalRecords={totalRecords}
          onChange={onPageChange}
        />
      </>
    )}

    {data.length === 0 && !isValidArray(data) && !isLoading && (
      <NoItemsPanel noItemsText={noDataText} canCreate={false} />
    )}
  </Stack>
);
